import { create } from 'sortablejs'
import { createAPI } from '../../common'

export default {
  //获取数字报权限设置
  getPermissionsPaper: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfs0qfsnjttjpot0bdujpot', 'get', config),
  // 修改数字报权限设置
  postPermissionPaper: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0qbqfs0qfsnjttjpot0bdujpot', 'post', config)
}
